import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()(() => ({
  message: { color: colors.gilead.primary1 },
}));
